import { CellColor } from 'almanac-ui/icons/16'
import { ActiveColorsIndicator } from 'common/Prose/components/ActiveColorsIndicator/ActiveColorsIndicator'
import { useActiveCellColorsInSelection } from 'common/Prose/hooks/useActiveCellColorsInSelection'
import { take } from 'lodash'
import { type EditorView } from 'prosemirror-view'
import Styles from './CellColorIcon.module.scss'

interface Props {
  view: EditorView
}

export const CellColorIcon = ({ view }: Props) => {
  const activeColors = useActiveCellColorsInSelection(view)

  return (
    <div className={Styles.wrapper}>
      <CellColor className={Styles.icon} />
      <ActiveColorsIndicator className={Styles.indicator} colors={take(activeColors, 4)} />
    </div>
  )
}
